import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { User } from '../../types/User/User.type.ts';

function PendingMemberTable({
  pendingMember,
  handleDeactivateUser,
  handleResendInvite,
}: {
  pendingMember: User;
  handleDeactivateUser: (email: string) => void;
  handleResendInvite: (email: string) => void;
}) {
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openResendModal, setOpenResendModal] = useState(false);

  const handleCancelModalOpen = () => {
    setOpenCancelModal(true);
  };

  const handleCancelModalClose = () => {
    setOpenCancelModal(false);
  };

  const handleDeleteConfirm = () => {
    handleDeactivateUser(pendingMember.email);
    setOpenCancelModal(false);
  };

  const handleResendModalOpen = () => {
    setOpenResendModal(true);
  };

  const handleResendModalClose = () => {
    setOpenResendModal(false);
  };

  const handleResendConfirm = () => {
    handleResendInvite(pendingMember.email);
    setOpenResendModal(false);
  };

  return (
    <TableRow key={pendingMember.id} hover>
      <TableCell>
        <Stack
          direction='row'
          spacing={2}
          sx={{
            alignItems: 'center',
          }}
        >
          <Avatar src={''} />
          <Stack>
            <Typography sx={{ fontSize: '12px', fontWeight: 'medium' }}>{pendingMember.email}</Typography>
          </Stack>
        </Stack>
      </TableCell>
      <TableCell align='right'>
        <Button variant='outlined' onClick={handleResendModalOpen} sx={{ marginRight: 2 }}>
          Resend invite
        </Button>
        <Button variant='outlined' onClick={handleCancelModalOpen}>
          Cancel invite
        </Button>
      </TableCell>
      <Dialog
        open={openCancelModal}
        onClose={handleCancelModalClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle sx={{ fontSize: '16px' }}>Cancel Invitation</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: '14px' }}>
            Are you sure you want to cancel invitation for the selected user?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelModalClose}>Close</Button>
          <Button onClick={handleDeleteConfirm} color='error' variant='contained' disableElevation>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openResendModal}
        onClose={handleResendModalClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle sx={{ fontSize: '16px' }}>Resend Invitation</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: '14px' }}>
            This will send a new invitation email to the selected user. Do you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResendModalClose}>Close</Button>
          <Button onClick={handleResendConfirm} variant='contained' disableElevation>
            Resend
          </Button>
        </DialogActions>
      </Dialog>
    </TableRow>
  );
}

export default PendingMemberTable;
